const countries = window.allCountries;

const createCountriesObjByKey = (tKey, valKey) => {
    return countries.reduce((acc, val) => {
        acc[val[tKey]] = val[valKey];
        return acc
    }, {});
}

export const localizedCountries = createCountriesObjByKey('iso', 'name');

export const countriesPhonePlaceholders = createCountriesObjByKey('iso', 'asterisk_placeholder');

export function getCountryCode(numberCode) {
    return countries.find(c => {
        return c.id === numberCode.toString()
    })?.iso || '';
}